import {useState} from 'react';
import * as Common from '../common/app_common.js';
import {Title} from '../common/component_common.js';
import '../common/css/control_system.css';
import * as System from './control_system/system.js';
import * as Tag from './control_system/tag.js';
import * as Location from './control_system/location.js';
import * as Database from './control_system/database.js';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { getPemission } from '../common/app_common.js';
import {DecideWindow} from '../common/modal_common.js';

const SystemTab = ({tabIndex, setTabIndex}) => {

    // useEffect(() => {
    //     //
    // }, []);

    // useInterval(() =>
    // {
    //     //
    // }, 10000 );

    return (
        <Tabs
            defaultActiveKey="System"
            transition={true}
            activeKey={tabIndex}
            onSelect={(k) => setTabIndex(k)}
            className="my-3" >
            <Tab tabClassName={`${tabIndex==="System"?"":"none-activate"}`} eventKey="System" title="System"/>
            <Tab tabClassName={`${tabIndex==="Tag"?"":"none-activate"}`} eventKey="Tag" title="Tag"/>
            <Tab tabClassName={`${tabIndex==="Location"?"":"none-activate"}`} eventKey="Location" title="Location"/>
            {getPemission() === 2 && <Tab eventKey="Database" title="Database"/>}
        </Tabs>
    )    
}

const PageControlSystem = () => {

    const [tabIndex, setTabIndex] = useState('System');
    const [pendingTab, setPendingTab] = useState(null);
    const [modalVisible, setModalVisible] = useState(false);
    const [existUpdate, setExistUpdate] = useState(false); // SiteEndpoint에서 변경사항 여부를 받아올 예정

    // 탭 이동 핸들러
    const handleTabChange = (nextTab) => {
        if (tabIndex === nextTab) return;
        if (existUpdate) {
            setPendingTab(nextTab);
            setModalVisible(true);
        } else {
            setTabIndex(nextTab);
        }
    };

    // 모달 OK 클릭 시
    const handleModalOk = (is) => {
        setModalVisible(false);
        if (is) {
            setTabIndex(pendingTab);
            setPendingTab(null);
            setExistUpdate(false);
        }
    };

    return (
        <>
            <Title title='System'></Title>
            <SystemTab tabIndex={tabIndex} setTabIndex={handleTabChange}></SystemTab>
            {tabIndex==='System'&&<System.View existUpdate={existUpdate} setExistUpdate={setExistUpdate}></System.View>}
            {tabIndex==='Tag'&&<Tag.View existUpdate={existUpdate} setExistUpdate={setExistUpdate}></Tag.View>}
            {tabIndex==='Location'&&<Location.View existUpdate={existUpdate} setExistUpdate={setExistUpdate}></Location.View>}
            {tabIndex==='Database'&&<Database.View></Database.View>}
            {modalVisible && (
                <DecideWindow
                    show={modalVisible}
                    handleClose={() => setModalVisible(false)}
                    body={<div className='text-center'><p>There are unsaved changes. Are you sure you want to leave this tab?</p></div>}
                    okButtonTxt={'OK'}
                    result={handleModalOk}
                />
            )}
        </>
    )
}

export default PageControlSystem;